import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Spinner from '../../../components/ui/spinner';
import { useAppSelector } from '../../../store';
import { setPage } from '../../../store/features/moments/momentsSlice';
import ButtonDot from '../home-feed/buttonDot';
import HelpCollapse from './helpCollapse';
import NoticeCollapse from './noticeCollapse';

const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        marginBottom: '10px',
        background: 'transparent',

        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: '0 0 15px 0',
        },
    },
    expanded: { margin: '0' },
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#FFF2E6',
        borderRadius: '12px',
        borderBottom: '1px solid transparent',
        marginBottom: -1,
        minHeight: 56,

        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
})(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
    root: {
        padding: '17px 10px 0 15px',
    },
}))(MuiAccordionDetails);

const AsideMenu = () => {
    const dispatch = useDispatch();
    const [expanded, setExpanded] = React.useState<string | false>('panel1');

    const { page } = useAppSelector(state => state.moments);
    const [subPage, setSubPage] = useState('');
    const [activeAccordionPage, setActiveAccordionPage] = useState('');

    const handleChange = (panel: string) => (event, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    const { departments, departmentsLoading, userTeamsLoading } = useAppSelector(state => state.moments.aside);
    const { tuttorialIndex, tutorial } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);

    // useEffect(() => {
    //     dispatch(getDepartments());
    //     dispatch(getAllEmployees());
    //     dispatch(getUserTeams());
    // }, [words]);

    const handleChangePage = (pageName: string, subPageName: string, accordionIndex: string, type: string, id: string) => {
        setSubPage(subPageName);
        setActiveAccordionPage(accordionIndex);
        dispatch(setPage({ name: pageName, type: type, id: id, index: accordionIndex }));
    };

    return (
        <div className={tuttorialIndex > 0 ? 'c-container-01 active' : 'c-container-01'}>
            <div className="moments-aside-menu">
                {departmentsLoading ? (
                    <div className="moments-aside-menu-spinner-container">
                        <Spinner />
                    </div>
                ) : (
                    <>
                        <a
                            href="/"
                            className={page.name === 'momentsHome' ? 'button-01 active ' : 'button-01 '}
                            onClick={() => (tuttorialIndex > 0 ? null : handleChangePage('momentsHome', '', '', '', ''))}>
                            <svg className="img-01" width="30" height="30" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="30" height="30" rx="8" fill="#00A3FF" />
                                <path
                                    d="M14.4996 5.38818L14.0118 5.8377L5.19043 14.3377L6.16588 15.2776L7.0353 14.4399V22H13.1424V15.4615H15.8567V22H21.9639V14.4399L22.8333 15.2776L23.8088 14.3377L14.9873 5.8377L14.4996 5.38818ZM14.4996 7.24756L20.6067 13.1322V20.6923H17.2139V14.1538H11.7853V20.6923H8.39244V13.1322L14.4996 7.24756Z"
                                    fill="white"
                                />
                            </svg>

                            <span className="text-01">{words && words['WEB.specialMoments']}</span>
                            <svg
                                className="accordion-arrow"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>

                        <div className={tuttorialIndex > 0 ? 'overlay-01 active' : 'overlay-01'}> </div>

                        {userTeamsLoading ? (
                            <Spinner />
                        ) : (
                            <div className={tuttorialIndex === 3 ? 'accordion-menu-01 active' : 'accordion-menu-01'}>
                                {tuttorialIndex === 3 && (
                                    <>
                                        <div className="aside-menu-tutorial">
                                            <ButtonDot description={tutorial?.items[2]?.description}></ButtonDot>
                                        </div>
                                    </>
                                )}

                                <a
                                    href="#!"
                                    className={page.name === 'myTeams' && subPage === '01' ? 'button-02 active' : 'button-02'}
                                    onClick={() => (tuttorialIndex > 0 ? null : handleChangePage('myTeams', '01', '', 'myTeams', ''))}>
                                    <svg className="img-01" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="30" height="30" rx="8" fill="#FF7A00" />
                                        <g clipPath="url(#clip0_1201_12548)">
                                            <path
                                                d="M19.1663 22.5V20.8333C19.1663 19.9493 18.8152 19.1014 18.19 18.4763C17.5649 17.8512 16.7171 17.5 15.833 17.5H9.16634C8.28229 17.5 7.43444 17.8512 6.80932 18.4763C6.1842 19.1014 5.83301 19.9493 5.83301 20.8333V22.5"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M12.5003 14.1667C14.3413 14.1667 15.8337 12.6743 15.8337 10.8333C15.8337 8.99238 14.3413 7.5 12.5003 7.5C10.6594 7.5 9.16699 8.99238 9.16699 10.8333C9.16699 12.6743 10.6594 14.1667 12.5003 14.1667Z"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M24.167 22.5001V20.8334C24.1664 20.0948 23.9206 19.3774 23.4681 18.7937C23.0156 18.2099 22.3821 17.793 21.667 17.6084"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M18.333 7.6084C19.05 7.79198 19.6855 8.20898 20.1394 8.79366C20.5932 9.37833 20.8395 10.0974 20.8395 10.8376C20.8395 11.5777 20.5932 12.2968 20.1394 12.8815C19.6855 13.4661 19.05 13.8831 18.333 14.0667"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1201_12548">
                                                <rect width="20" height="20" fill="white" transform="translate(5 5)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span className="text-01">{words && words['WEB.myTeams']}</span>
                                    <svg
                                        className="accordion-arrow"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </a>

                                {departments.length > 1 && (
                                    <>
                                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                                            <AccordionSummary className="accordion-header" aria-controls="panel1d-content" id="panel1d-header">
                                                <div
                                                    className={
                                                        page.name === 'myTeams' && subPage === 'accordionPages' ? 'button-02 active' : 'button-02'
                                                    }>
                                                    <svg
                                                        className="img-01"
                                                        width="30"
                                                        height="30"
                                                        viewBox="0 0 30 30"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="30" height="30" rx="8" fill="#FF7A00" />
                                                        <g clipPath="url(#clip0_1201_12557)">
                                                            <path
                                                                d="M18.333 22.5V20.8333C18.333 19.9493 17.9818 19.1014 17.3567 18.4763C16.7316 17.8512 15.8837 17.5 14.9997 17.5H9.16634C8.28229 17.5 7.43444 17.8512 6.80932 18.4763C6.1842 19.1014 5.83301 19.9493 5.83301 20.8333V22.5"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M12.0833 14.1667C13.9243 14.1667 15.4167 12.6743 15.4167 10.8333C15.4167 8.99238 13.9243 7.5 12.0833 7.5C10.2424 7.5 8.75 8.99238 8.75 10.8333C8.75 12.6743 10.2424 14.1667 12.0833 14.1667Z"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M21.667 11.6665V16.6665"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M24.167 14.1665H19.167"
                                                                stroke="white"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_1201_12557">
                                                                <rect width="20" height="20" fill="white" transform="translate(5 5)" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>

                                                    <span className="text-01"> {words && words['WEB.relationTeams']}</span>
                                                    <svg
                                                        className={expanded ? 'active accordion-arrow' : 'accordion-arrow'}
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M9 18L15 12L9 6"
                                                            stroke="#6C6C7D"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </AccordionSummary>
                                            {departmentsLoading ? (
                                                <Spinner />
                                            ) : (
                                                departments
                                                    .filter(x => x.showMenu)
                                                    .map((item, index) => {
                                                        return (
                                                            <AccordionDetails key={'accordion-items' + index}>
                                                                <a
                                                                    href="#!"
                                                                    className={
                                                                        page.name === 'myTeams' &&
                                                                        activeAccordionPage === index.toString() &&
                                                                        subPage === 'accordionPages'
                                                                            ? 'button-03 active'
                                                                            : 'button-03'
                                                                    }
                                                                    onClick={() =>
                                                                        tuttorialIndex > 0
                                                                            ? null
                                                                            : handleChangePage(
                                                                                  'myTeams',
                                                                                  'accordionPages',
                                                                                  index.toString(),
                                                                                  'departmants',
                                                                                  item.departmentId,
                                                                              )
                                                                    }>
                                                                    <span className="text-01">{item.departmantName}</span>
                                                                    <svg
                                                                        className="accordion-arrow"
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M9 18L15 12L9 6"
                                                                            stroke="#6C6C7D"
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        />
                                                                    </svg>
                                                                </a>
                                                            </AccordionDetails>
                                                        );
                                                    })
                                            )}
                                        </Accordion>

                                        <a
                                            href="#!"
                                            className={page.name === 'myTeams' && subPage === '03' ? 'button-02 active' : 'button-02'}
                                            onClick={() => (tuttorialIndex > 0 ? null : handleChangePage('myTeams', '03', '', 'allEmployees', ''))}>
                                            <svg
                                                className="img-01"
                                                width="30"
                                                height="30"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <rect width="30" height="30" rx="8" fill="#FF7A00" />
                                                <g clipPath="url(#clip0_1201_12571)">
                                                    <path
                                                        d="M18.333 22.5V20.8333C18.333 19.9493 17.9818 19.1014 17.3567 18.4763C16.7316 17.8512 15.8837 17.5 14.9997 17.5H9.16634C8.28229 17.5 7.43444 17.8512 6.80932 18.4763C6.1842 19.1014 5.83301 19.9493 5.83301 20.8333V22.5"
                                                        stroke="white"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M12.0833 14.1667C13.9243 14.1667 15.4167 12.6743 15.4167 10.8333C15.4167 8.99238 13.9243 7.5 12.0833 7.5C10.2424 7.5 8.75 8.99238 8.75 10.8333C8.75 12.6743 10.2424 14.1667 12.0833 14.1667Z"
                                                        stroke="white"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M19.167 14.1667L20.8337 15.8333L24.167 12.5"
                                                        stroke="white"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_1201_12571">
                                                        <rect width="20" height="20" fill="white" transform="translate(5 5)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <span className="text-01">{words && words['WEB.allTeams']}</span>
                                            <svg
                                                className="accordion-arrow"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M9 18L15 12L9 6"
                                                    stroke="#6C6C7D"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </a>
                                    </>
                                )}
                            </div>
                        )}

                        <div className={tuttorialIndex > 0 ? 'overlay-01 active' : 'overlay-01'}> </div>
                        <div className={tuttorialIndex === 6 ? 'accordion-menu-02 active' : 'accordion-menu-02'}>
                            <a
                                href="#!"
                                className={
                                    tuttorialIndex === 6 ? 'button-01 tutorial' : page.name === 'specialMoments' ? 'button-01 active' : 'button-01'
                                }
                                onClick={() => (tuttorialIndex > 0 ? null : handleChangePage('specialMoments', '', '', '', ''))}>
                                {tuttorialIndex === 6 && (
                                    <>
                                        <div className="special-moment-content-tutorial">
                                            <ButtonDot description={tutorial?.items[5]?.description}></ButtonDot>
                                        </div>
                                    </>
                                )}
                                <svg className="img-01" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="30" height="30" rx="8" fill="#F42E36" />
                                    <path
                                        d="M22.0167 8.81671C21.5987 8.39719 21.1019 8.06433 20.5549 7.8372C20.0079 7.61008 19.4215 7.49316 18.8292 7.49316C18.237 7.49316 17.6505 7.61008 17.1036 7.8372C16.5566 8.06433 16.0598 8.39719 15.6417 8.81671L15.0001 9.46671L14.3584 8.81671C13.9403 8.39719 13.4436 8.06433 12.8966 7.8372C12.3496 7.61008 11.7632 7.49316 11.1709 7.49316C10.5786 7.49316 9.9922 7.61008 9.44522 7.8372C8.89824 8.06433 8.40147 8.39719 7.98341 8.81671C6.21674 10.5834 6.10841 13.5667 8.33341 15.8334L15.0001 22.5L21.6667 15.8334C23.8917 13.5667 23.7834 10.5834 22.0167 8.81671Z"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                <span className="text-01">{words && words['WEB.specialMomentsContents']}</span>
                                <svg
                                    className="accordion-arrow"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </a>
                        </div>
                    </>
                )}

                <NoticeCollapse />
                <HelpCollapse />
            </div>
        </div>
    );
};

export default AsideMenu;
